import { useCallback, useEffect, useRef, useState } from "react";

export type WorkspaceMode = "simple" | "advanced";

function readMode(siteId: string): WorkspaceMode {
  try {
    return window.localStorage.getItem(`bw-mode:${siteId}`) === "advanced" ? "advanced" : "simple";
  } catch {
    return "simple";
  }
}

export function useWorkspaceMode(siteId: string): [WorkspaceMode, (mode: WorkspaceMode) => void] {
  const [mode, setModeState] = useState<WorkspaceMode>(() => typeof window === "undefined" ? "simple" : readMode(siteId));
  const previousSiteId = useRef(siteId);

  useEffect(() => {
    if (previousSiteId.current === siteId) return;
    previousSiteId.current = siteId;
    setModeState(typeof window === "undefined" ? "simple" : readMode(siteId));
  }, [siteId]);

  const setMode = useCallback((next: WorkspaceMode) => {
    setModeState(next);
    try {
      window.localStorage.setItem(`bw-mode:${siteId}`, next);
    } catch {
      // The preference is optional when storage is unavailable.
    }
  }, [siteId]);

  return [mode, setMode];
}
